import { render } from "./CashbackCreateBoard.vue?vue&type=template&id=06423927&scoped=true"
import script from "./CashbackCreateBoard.vue?vue&type=script&lang=js"
export * from "./CashbackCreateBoard.vue?vue&type=script&lang=js"

import "./CashbackCreateBoard.vue?vue&type=style&index=0&id=06423927&lang=scss&scoped=true"
import "./CashbackCreateBoard.vue?vue&type=style&index=1&id=06423927&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06423927"]])

export default __exports__